import {Ref, computed} from 'vue';
import {PolyDictionary} from '../../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {AttribType, AttribClass} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/Constant';
import {CoreGroup} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/Group';
import {attribClassClassObject, BuildHeaders, BuildTableData} from './Common';
import { CoreObjectType } from '../../../../../../@polygonjs/polygonjs/src/core/geometry/ObjectContent';
import { CorePoint } from '../../../../../../@polygonjs/polygonjs/src/core/geometry/entities/point/CorePoint';

interface SetupForPointOptions {
	selectedAttribClass: Ref<AttribClass>;
	pointAttribNames: Ref<string[]>;
	buildHeaders: BuildHeaders;
	buildTableData: BuildTableData;
}

export function SetupForPoint(options: SetupForPointOptions) {
	const {selectedAttribClass, pointAttribNames, buildHeaders, buildTableData} = options;

	const classObjectPointButton = computed(() => {
		return attribClassClassObject(selectedAttribClass.value == AttribClass.POINT);
	});
	function setAttribClassPoint() {
		selectedAttribClass.value = AttribClass.POINT;
	}

	//
	//
	// POINTS
	//
	//
	function build(coreGroup: CoreGroup) {
		pointAttribNames.value = coreGroup.pointAttribNames();
		const attrib_sizes = coreGroup.pointAttribSizes();
		const attrib_types_by_name: PolyDictionary<AttribType> = {};
		for (let name of pointAttribNames.value) {
			const type = coreGroup.pointAttribType(name);
			if (type) {
				attrib_types_by_name[name] = type;
			}
		}
		buildHeaders(pointAttribNames.value, attrib_sizes, attrib_types_by_name);
		const points:CorePoint<CoreObjectType>[]=[]
		buildTableData(coreGroup.points(points), pointAttribNames.value, attrib_sizes);
	}

	return {
		classObjectPointButton,
		setAttribClassPoint,
		build,
	};
}
